module.exports = __webpack_public_path__ + "static/media/back.3fa8ebef.svg";